import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import i18n from "i18n";
import { Alert, Col, Row } from "components/bootstrap";
import { Link } from "components/common";
import usePermissions from "hooks/usePermissions";
import AIManagementRoutes from "ai-management/Routes";
import ProviderName from "ai-management/components/ProviderName";
import useAIFeaturesStatus from "ai-management/hooks/useAIFeaturesStatus";
const Alerts = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};
  `
);
const StyledAlert = styled(Alert)`
  margin: 0;
`;
const modelProvidersLink = /* @__PURE__ */ React.createElement(Link, { to: AIManagementRoutes.MODEL_PROVIDERS });
const issueAlertContent = (issue, linkToModelProviders) => {
  switch (issue.type) {
    case "no_model_provider":
      return {
        title: i18n.t("issue.no_model_provider.title", { ns: "enterprise_ai" }),
        message: linkToModelProviders ? /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: "enterprise_ai",
            i18nKey: "issue.no_model_provider.message_with_link",
            components: { modelProvidersLink }
          }
        ) : i18n.t("issue.no_model_provider.message", { ns: "enterprise_ai" })
      };
    case "no_default_model_provider":
      return {
        title: i18n.t("issue.no_default_model_provider.title", { ns: "enterprise_ai" }),
        message: linkToModelProviders ? /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: "enterprise_ai",
            i18nKey: "issue.no_default_model_provider.message_with_link",
            components: { modelProvidersLink }
          }
        ) : i18n.t("issue.no_default_model_provider.message", { ns: "enterprise_ai" })
      };
    case "default_model_provider_disabled": {
      const components = { modelProvidersLink, providerName: /* @__PURE__ */ React.createElement(ProviderName, { providerId: issue.provider }) };
      return {
        title: i18n.t("issue.default_model_provider_disabled.title", { ns: "enterprise_ai" }),
        message: linkToModelProviders ? /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: "enterprise_ai",
            i18nKey: "issue.default_model_provider_disabled.message_with_link",
            components
          }
        ) : /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: "enterprise_ai",
            i18nKey: "issue.default_model_provider_disabled.message",
            components
          }
        )
      };
    }
  }
};
const ModelProviderIssueAlert = ({ issue, linkToModelProviders }) => {
  const { title, message } = issueAlertContent(issue, linkToModelProviders);
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title }, message);
};
const AIFeaturesStatusAlerts = ({ isModelProvidersPage = false }) => {
  const { t } = useTranslation("enterprise_ai");
  const { isPermitted } = usePermissions();
  const { aiDisabled, modelProviderIssue } = useAIFeaturesStatus();
  const showAIDisabled = aiDisabled && !isModelProvidersPage;
  const shownModelProviderIssue = aiDisabled ? void 0 : modelProviderIssue;
  const linkToModelProviders = !isModelProvidersPage && isPermitted("llm_provider:edit");
  if (!showAIDisabled && !shownModelProviderIssue) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alerts, null, showAIDisabled && /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title: t("ai_features_disabled.title") }, linkToModelProviders ? /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "ai_features_disabled.message_with_link", components: { modelProvidersLink } }) : t("ai_features_disabled.message")), shownModelProviderIssue && /* @__PURE__ */ React.createElement(ModelProviderIssueAlert, { issue: shownModelProviderIssue, linkToModelProviders }))));
};
export default AIFeaturesStatusAlerts;
